import { Typography } from "@material-ui/core"
import styled from "styled-components"

const SectionContainer = styled("div")`
  display: flex;
  align-items: center;
  gap: 16px;

  ${(p) => p.theme.breakpoints.down("sm")} {
    gap: 8px;
  }
`

const StyledImg = styled("img")`
  width: 56px;
  height: 56px;

  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 40px;
    height: 40px;
  }
`

const StyledTitle = styled(Typography).attrs({
  variant: "h2",
})`
  color: #000;
  font-family: NarkisBlock;
  font-size: 32px;
  font-style: normal;
  font-weight: bold;
  line-height: normal;
  letter-spacing: 0.48px;

  ${(p) => p.theme.breakpoints.down("sm")} {
    font-size: 24px;
    letter-spacing: 0.36px;
  }
`

type FormSectionTitleType = {
  imgSrc: string
  imgAlt: string
  titleText: string
}

const FormSectionTitle = ({
  imgSrc,
  imgAlt,
  titleText,
}: FormSectionTitleType) => {
  return (
    <SectionContainer>
      <StyledImg src={imgSrc} alt={imgAlt} />
      <StyledTitle>{titleText}</StyledTitle>
    </SectionContainer>
  )
}

export default FormSectionTitle
